var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"el-icon-arrow-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }